module.exports = __webpack_public_path__ + "static/media/buy_tickets.3bd8b99b.mp3";